export default [
    {
        path: '/skills',
        name: 'skills',
        meta: {
            layout: 'dashboard'
        },
        component: () => import('VIEWS/Catalogs/Skills.vue')
    }
]